import * as THREE from 'three';

export function createExplosion(scene, position, explosionMaterial) {
    const explosion = new THREE.Sprite(explosionMaterial);
    explosion.position.copy(position);
    explosion.scale.set(0.5, 0.5, 0.5);
    scene.add(explosion);

    const startTime = performance.now();
    const duration = 500;

    function animateExplosion() {
        const now = performance.now();
        const elapsed = now - startTime;
        const t = elapsed / duration;

        if(t < 1) {
            const scale = THREE.MathUtils.lerp(0.25, 0.75, t);
            explosion.scale.set(scale, scale, scale);
            explosion.material.opacity = 1.0 - t;
            requestAnimationFrame(animateExplosion);
        } else {
            scene.remove(explosion);
        }
    }

    animateExplosion();
}